import React, { useCallback, useState } from 'react';
import { texts } from 'utils/languages/fr';
import TunnelManagement from './tunnels/TunnelManagement';
import TunnelMenu from './tunnels/TunnelMenu';
import { ExpandableList } from 'components';
import TunnelActiveVersion from './tunnels/TunnelActiveVersion';

const tabKeys = {
    CONTROL: 'control',
    FORM: 'form',
    ACTIVE_VERSION: 'active_version',
};

const Tunnels = () => {
    const [tab, setTab] = useState(tabKeys.CONTROL);

    const handleTabChange = useCallback(newTab => {
        setTab(newTab);
    }, []);

    return (
        <ExpandableList title={texts.TUNNELS}>
            {tab === tabKeys.CONTROL && (
                <TunnelMenu
                    onManage={() => handleTabChange(tabKeys.FORM)}
                    onShowActiveVersion={() => handleTabChange(tabKeys.ACTIVE_VERSION)}
                />
            )}
            {tab === tabKeys.FORM && (
                <TunnelManagement onCancel={() => handleTabChange(tabKeys.CONTROL)} />
            )}
            {tab === tabKeys.ACTIVE_VERSION && (
                <TunnelActiveVersion onCancel={() => handleTabChange(tabKeys.CONTROL)} />
            )}
        </ExpandableList>
    );
};

export default Tunnels;
